/** Single home for the Bearer scheme prefix so the i18n prose linter has one place to grandfather. */
const authorizationHeader = (token: string): string => `Bearer ${token}`;

export default authorizationHeader;
